import { Row, Col, ToastContainer, Toast } from 'react-bootstrap';
import { ApiDataWrapper } from '../UIExtentions/ApiDataWrapper';
import { ActionButton } from '../UIExtentions/Buttons';
import { useState } from 'react';
import { ICertificate } from '../../api/models';
import { ValidFromDateDisplay } from '../Shared/ValidFromDateDisplay';
import { ValidToDateDisplay } from '../Shared/ValidToDateDisplay';

interface CertificateDetailsProps {
    certificate: ICertificate;
}

export const CertificateInfoView = (props: any) => {
    return (
        <>
            <ApiDataWrapper
                objectType="Certificate Info"
                objectName={props.thumbprint}
                isLoading={props.isLoading}
                isDataNotFound={props.isDataNotFound}
                errorMessage={props.errorMessage}
            >
                <CertificateDetails certificate={props.certificate} />
            </ApiDataWrapper>
        </>
    );
};

export function CertificateDetails(props: CertificateDetailsProps) {
    const certificate = props.certificate;

    const [showCopyToast, setShowCopyToast]: [boolean, Function] = useState(false);

    function copyValue(value: any) {
        navigator.clipboard.writeText(value);
        setShowCopyToast(true);
    }

    return (
        <>
            <ToastContainer style={{ zIndex: 999 }} position="middle-center">
                <Toast onClose={() => setShowCopyToast(false)} show={showCopyToast} delay={2000} autohide bg="white">
                    <Toast.Header>
                        <strong className="me-auto">Copied!</strong>
                    </Toast.Header>
                    <Toast.Body>Value copied successfully.</Toast.Body>
                </Toast>
            </ToastContainer>

            <Row>
                <Col sm={2}>Thumbprint:</Col>
                <Col>
                    {certificate.thumbprint} <ActionButton icon="fa-copy" variant="btn-dark-blue" title="Copy" onClick={() => copyValue(certificate.thumbprint)} />
                </Col>
            </Row>
            <Row>
                <Col sm={2}>Common Name:</Col>
                <Col>{certificate.commonName}</Col>
            </Row>
            <Row>
                <Col sm={2}>Friendly Name:</Col>
                <Col>{certificate.friendlyName}</Col>
            </Row>
            <Row>
                <Col sm={2}>Subject:</Col>
                <Col>{certificate.subject}</Col>
            </Row>
            <Row>
                <Col sm={2}>Alternative Subject:</Col>
                <Col>{certificate.subjectAlternativeName}</Col>
            </Row>
            <Row>
                <Col sm={2}>Issuer:</Col>
                <Col>{certificate.issuer}</Col>
            </Row>
            <Row>
                <Col sm={2}>Key Usages:</Col>
                <Col>{certificate.keyUsages}</Col>
            </Row>
            <Row>
                <Col sm={2}>Email:</Col>
                <Col>
                    {certificate.email}{' '}
                    {certificate.email ? <ActionButton icon="fa-copy" variant="btn-dark-blue" title="Copy" onClick={(e: any) => copyValue(certificate.email)} /> : ''}
                </Col>
            </Row>
            <Row>
                <Col sm={2}>Valid From:</Col>
                <Col>
                    <ValidFromDateDisplay date={certificate.validFrom} />
                </Col>
            </Row>
            <Row>
                <Col sm={2}>Valid To:</Col>
                <Col>
                    <ValidToDateDisplay date={certificate.validTo} />
                </Col>
            </Row>
        </>
    );
}
